import { useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';

import Actionbar from 'src/components/common/actionbar/Authactionbar';
import useUiuxStore from 'src/store/useUiuxStore';
import { useMouseContent } from 'src/utils/mouse/mouseContent';

import Content_SAL2060_R01 from './Content_SAL2060_R01';
import SearchSection_SAL2060_R01 from './SearchSection_SAL2060_R01';
import { useSAL2060_R01Store } from './Store_SAL2060_R01';
import { Table_SAL2060_R01 } from './Table_SAL2060_R01';
import DetailTable_SAL2060_R01 from './DetailTable_SAL2060_R01';
import { SAL2060_R01HeaderDto, SAL2060_R01DetailDto } from './Dto_SAL2060_R01';
import {Message} from "src/components/common/form/Message";

const Container_SAL2060_R01 = () => {
    // ========================================
    // Store
    // ========================================
    const { headerAllCount } = useSAL2060_R01Store();
    const { setMessage } = useUiuxStore();

    // ========================================
    // Refs
    // ========================================
    const headerGridRef = useRef<AgGridReact<SAL2060_R01HeaderDto>>(null);
    const detailGridRef = useRef<AgGridReact<SAL2060_R01DetailDto>>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const detailRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    // ========================================
    // 리사이저 설정
    // ========================================
    const RESIZER = {
        code: 'SAL2060_R01',
        type: 'width',
        storageKey: 'SAL2060_R01-split-width',
        min: 20,
        max: 70,
        default: 33
    } as const;

    const { 
        splitValue,
        handleMouseDown,
        handleMouseUp
    } = useMouseContent({
        resizer: RESIZER,
        isResizing,
        containerRef,
        infoRef: detailRef
    });

    // ========================================
    // Content Hook (비즈니스 로직)
    // ========================================
    const { fetchHeaderData, fetchDetailData, handleExcelClick, initContainerData } =
        Content_SAL2060_R01({
            headerGridRef,
            detailGridRef,
            setMessage,
        });

    // ========================================
    // UI 렌더링
    // ========================================
    return (
        <div className="content-container">
            {/* Action Bar */}
            <Actionbar
                onFetchClick={fetchHeaderData}
                onCreateClick={undefined} // 조회 전용
                onDeleteClick={undefined} // 조회 전용
                onSaveClick={undefined} // 조회 전용
                onPrintClick={undefined} // 미사용
                onExcelClick={handleExcelClick}
                onInitClick={initContainerData}
            />

            {/* Search Section */}
            <SearchSection_SAL2060_R01 onEnterKeyDown={fetchHeaderData} />

            {/* Grid Container: 좌우 분할 */}
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
                {/* 좌측: Header (거래처별 집계) */}
                <div className="h-full" style={{ width: `${splitValue}%` }}>
                    <Table_SAL2060_R01
                        gridRef={headerGridRef}
                        onCustomerSelect={fetchDetailData}
                    />
                </div>

                {/* 리사이저 */}
                <div
                    className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
                    onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
                    onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
                />

                {/* 우측: Detail (상세 내역) */}
                <div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={detailRef}>
                    <DetailTable_SAL2060_R01 gridRef={detailGridRef} />
                </div>
            </div>

            <Message />
        </div>
    );
};

export default Container_SAL2060_R01;
